export default __webpack_public_path__ + "static/media/Logo_Trust_BRISTOW@3x.cb842067.png";